var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", {
    ref: "content",
    staticClass: "gfu-richtext gfu-richtext--article",
    domProps: { innerHTML: _vm._s(_vm.processedHtml) },
    on: { click: _vm.onEventClickDelegation },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }